import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { Environment } from './environments/environment';

if (Environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));

try {
  // tempusdominus-bootstrap-4 v5.0.0-alpha8
  (function fixDateTimePickerCloseButton() {
    this._oldDoAction = this._doAction;
    this._doAction = function (e, action) {
      let result = this._oldDoAction.apply(this, arguments);
      (action || e.currentTarget.dataset.action) === 'close' && this.hide();
      return result;
    };
  }).call(jQuery.fn.datetimepicker.Constructor.prototype);

  // moment.js
  (function configureMoment() {
    let nav = window && <any>window.navigator;
    if (nav) {
      let language = (nav.languages && nav.languages[0] || nav.language || nav.userLanguage) || 'en';
      if (/en-GB/i.test(language)) {
        language = 'en-AU';
      }
      moment.locale(language);
    }
  })();
} catch (err) {
  console.log(err);
}



// WEBPACK FOOTER //
// ./src/main.ts